/* unplugin-vue-components disabled */import { render } from "./member_shou.vue?vue&type=template&id=73c89eb2&scoped=true"
import script from "./member_shou.vue?vue&type=script&lang=js"
export * from "./member_shou.vue?vue&type=script&lang=js"

import "./member_shou.vue?vue&type=style&index=0&id=73c89eb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c89eb2"]])

export default __exports__